import {
  DisruptionModel,
  PreventabilityDisruptionFactorType,
  SeverityDisruptionFactorType,
  TransmissibilityDisruptionFactorType,
} from 'client/dto';

export const countRiskFactors: (disruption: DisruptionModel) => number = (
  disruption: DisruptionModel
) => {
  let riskFactorsCount = 0;
  if (
    disruption?.transmissibility === TransmissibilityDisruptionFactorType.PossibleViaEnvironment ||
    disruption?.transmissibility === TransmissibilityDisruptionFactorType.PossibleViaHumanToHuman ||
    disruption?.transmissibility ===
      TransmissibilityDisruptionFactorType.PossibleViaEnvironmentLocally
  ) {
    riskFactorsCount++;
  }
  if (
    disruption?.severity === SeverityDisruptionFactorType.MildToModerate ||
    disruption?.severity === SeverityDisruptionFactorType.Moderate ||
    disruption?.severity === SeverityDisruptionFactorType.ModerateToSevere ||
    disruption?.severity === SeverityDisruptionFactorType.Severe
  ) {
    riskFactorsCount++;
  }
  if (
    disruption?.preventability === PreventabilityDisruptionFactorType.NoVaccineOrProphylaxis ||
    disruption?.preventability === PreventabilityDisruptionFactorType.LimitedVaccine
  ) {
    riskFactorsCount++;
  }
  if (disruption?.locationResiliency !== null && disruption?.locationResiliency < 75) {
    riskFactorsCount++;
  }

  return riskFactorsCount;
};
